<div
  class="video-call-container"
  *ngIf="(videoCallEnabled$ | async) && (clinicVideoCallLoaded$ | async)"
>
  <salve-clinic-video-call
    [video_call_id]="videoCallId$ | async"
    [language]="selectedLanguage$ | async"
    [clinic_token]="xSalveClinicToken$ | async"
  ></salve-clinic-video-call>
</div>
